export default __webpack_public_path__ + "static/media/hiking-fragrance-lake.00897f3b.jpeg";